module.exports = __webpack_public_path__ + "img/brand-logo.7b7f2dbb.svg";